import { useState } from "react"

const STREAMS = [
  {
    id: "science",
    label: "Science",
    description: "Physics, chemistry, biology, mathematics — for future doctors, engineers, and researchers.",
    color: "border-teal-300 bg-teal-50",
    selectedColor: "border-teal-500 bg-teal-100",
    dot: "bg-teal-500",
  },
  {
    id: "arts",
    label: "Arts & Humanities",
    description: "Literature, history, social studies, languages — for lawyers, writers, and social scientists.",
    color: "border-violet-300 bg-violet-50",
    selectedColor: "border-violet-500 bg-violet-100",
    dot: "bg-violet-500",
  },
  {
    id: "commerce",
    label: "Commerce",
    description: "Economics, accounting, business studies — for entrepreneurs, accountants, and finance professionals.",
    color: "border-amber-300 bg-amber-50",
    selectedColor: "border-amber-500 bg-amber-100",
    dot: "bg-amber-500",
  },
  {
    id: "general",
    label: "General / Not Sure Yet",
    description: "Mix of subjects across disciplines — for those still exploring their options.",
    color: "border-slate-200 bg-slate-50",
    selectedColor: "border-slate-400 bg-slate-100",
    dot: "bg-slate-400",
  },
]

export function StreamStep({ onNext }) {
  const [selected, setSelected] = useState(null)

  return (
    <div className="space-y-6">
      <div className="text-center space-y-1">
        <h2 className="text-2xl font-black text-slate-900">What&apos;s your stream?</h2>
        <p className="text-sm text-slate-500">This helps us recommend the right career paths for you.</p>
      </div>

      <div className="space-y-3">
        {STREAMS.map((stream) => {
          const isSelected = selected === stream.id
          return (
            <button
              key={stream.id}
              onClick={() => setSelected(stream.id)}
              className={`w-full text-left p-4 rounded-2xl border-2 transition-all ${
                isSelected ? stream.selectedColor : stream.color
              } hover:scale-[1.01] active:scale-[0.99]`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-3 h-3 rounded-full shrink-0 ${stream.dot}`} />
                <div>
                  <p className="font-bold text-slate-900 text-sm">{stream.label}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{stream.description}</p>
                </div>
                {isSelected && (
                  <div className="ml-auto shrink-0 w-5 h-5 rounded-full bg-indigo-600 flex items-center justify-center">
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 12 12">
                      <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                )}
              </div>
            </button>
          )
        })}
      </div>

      <button
        disabled={!selected}
        onClick={() => onNext({ stream: selected })}
        className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:opacity-40 text-white font-bold py-3 rounded-xl text-sm transition-all active:scale-95"
      >
        Continue
      </button>
    </div>
  )
}
